import { ErrorHandler } from 'src/error/ErrorHandler'
import { ErrorReporter } from 'src/error/ErrorReporter'
import { UserSession } from 'src/auth/SessionHolder'
import { ApiClient } from 'src/api/client/ApiClient'

export type ErrorAppContext = {
    handler: ErrorHandler
}

export const errorAppCtx = (
    storage: Storage,
    session: UserSession,
    getUserName: () => string | null,
    win: Window,
    api: ApiClient
): ErrorAppContext => {
    const reporter = new ErrorReporter(api)
    return {
        handler: new ErrorHandler(reporter, storage, session, getUserName, win)
    }
}
